import gql from 'graphql-tag'
import { EntityFields, EnumFields } from '..'

export const BusinessApproachFragment = gql`
  fragment BusinessApproach on settings_business_approach {
    ${EntityFields}
    ${EnumFields}
  }
`
